import React from 'react';
import tips from 'src/configs/tips';
import { Quote } from '@livable/saas-react-components';
import useStyles from './styles';
export default function LoginLeftContent() {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.xxlSection
  }, /*#__PURE__*/React.createElement(Quote, {
    tips: tips
  }));
}